export default __webpack_public_path__ + "static/media/416.2fb4a502.png";